import { LoadingButton } from '@mui/lab';
import { Box, DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useCreateCellNode from 'api/locationsCategories/useCreateCellNode';
import { useForm } from 'react-hook-form';

import { cellFieldValidationValues } from '../constants';

const CreateCellNodeModal = props => {
  const { guid } = props;

  const [createLoading, createCellNode] = useCreateCellNode();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      name: '',
    },
  });

  const onSubmit = data => {
    createCellNode(
      {
        partGuid: guid,
        name: data.name,
      },
      props.refreshData,
    );
  };

  const handleClose = () => {
    props.closeHandler();
    reset();
  };

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      sx={{ direction: 'rtl' }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleSubmit(onSubmit)();
        }
      }}
    >
      <DialogTitle>افزودن سلول</DialogTitle>

      <DialogContent>
        <Box sx={{ width: 320 }}>
          <FormControl sx={{ m: 1, minWidth: 300 }}>
            <TextField
              autoFocus
              label="عنوان سلول"
              variant="standard"
              {...register('name', cellFieldValidationValues)}
              error={isSubmitted ? !!errors.name : false}
              helperText={errors.name?.message || ''}
            />
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={createLoading}
          onClick={handleSubmit(onSubmit)}
        >
          تایید
        </LoadingButton>

        <LoadingButton
          variant="contained"
          color="warning"
          loading={createLoading}
          onClick={handleClose}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCellNodeModal;
